import { z } from 'zod';
import { assertTypes, type NoNewFields } from '../../primitives';

/**
 * The Square customer a venue's customer pays as (`squareConnectionSchema.ts`), so their payments
 * and saved cards sit on one customer in the seller's Square account. Found by the customer's
 * verified phone, else created. Per seller: a venue that links another Square account gets a new
 * one.
 */
export const squareCustomerSchema = z.object({
  restaurantCustomerId: z.string(),
  merchantId: z.string(),
  squareCustomerId: z.string(),

  _creationTime: z.number().optional(),
  _id: z.string().optional(),
  updatedAt: z.number().optional(),
});
export type SquareCustomer = z.output<typeof squareCustomerSchema>;

/** Strict schema */
export const squareCustomerStrictSchema = squareCustomerSchema;

/** Convex schema */
export const squareCustomerCvxSchema = squareCustomerSchema.safeExtend({
  _creationTime: z.number(),
  _id: z.string(),
  updatedAt: z.number(),
});
export type SquareCustomerCvx = z.output<typeof squareCustomerCvxSchema>;
assertTypes<NoNewFields<SquareCustomer, SquareCustomerCvx>>();
